import React from 'react';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { DndProvider } from 'react-dnd';
import DraggableHeaderCell from './DraggableHeaderCell';
import RowDragLayer from './RowDragLayer';
import { utils } from 'components/react-data-grid';
import PropTypes from 'prop-types';

const { isColumnsImmutable } = utils;

const DraggableContainer = props => {
  const grid = React.Children.map(props.children, child => {
    return React.cloneElement(child, {
      draggableHeaderCell: DraggableHeaderCell,
    });
  })[0];
  const rowGetter = props.getDragPreviewRow || grid.props.rowGetter;
  const rowsCount = grid.props.rowsCount;
  const columns = grid.props.columns;

  let rows = [];
  for (let j = 0; j < rowsCount; j++) {
    rows.push(rowGetter(j));
  }

  return (
    <div>
      {grid}
      <RowDragLayer
        rowSelection={grid.props.rowSelection}
        rows={rows}
        columns={isColumnsImmutable(columns) ? columns.toArray() : columns}
      />
    </div>
  );
};

DraggableContainer.propTypes = {
  children: PropTypes.element.isRequired,
  getDragPreviewRow: PropTypes.func,
};

const withDragDropContext = Component => {
  return props => {
    return (
      <DndProvider backend={HTML5Backend}>
        <Component {...props} />
      </DndProvider>
    );
  };
};

export default withDragDropContext(DraggableContainer);
